/** The traces period a live dataset's version was pulled from ("1–7 Oct"), or "" for a static version. */

import { formatPeriod } from "@/features/experiments/detail/trace-run";
import type { Dataset, DatasetVersion } from "../types";

export const isLive = (d: Pick<Dataset, "kind">) => d.kind === "live";

export function versionPeriod(v: Pick<DatasetVersion, "period_start" | "period_end"> | null | undefined) {
  if (!v?.period_start || !v.period_end) return "";
  return formatPeriod({ start: v.period_start, end: v.period_end });
}
